const firebaseConfig = {
    apiKey: "AIzaSyAMqNeRVAEK-PVYEn9dBuax34Y0vmhjdyw",
    authDomain: "frankfurter-buchmesse-215114.firebaseapp.com",
    databaseURL: "https://frankfurter-buchmesse-215114.firebaseio.com",
    projectId: "frankfurter-buchmesse-215114",
    storageBucket: "frankfurter-buchmesse-215114.appspot.com",
    messagingSenderId: "444374624125",
    appId: "1:444374624125:web:17f0a5384bfc16dfb18e14"
};

const vapidKey = "BH7pxq1Im5-h1tWI8boJkwkvOsjzKpkH7ns0d1S_e8dhaA-4S9IiwKCrfJyNcLa7Nb8soK2znZVWWDej-N1PqxI";

export {
    firebaseConfig,
    vapidKey
}